import * as system from 'durandal/system';

import * as userService from '@/legacy/services/user';
import * as plootoUtils from '@/legacy/utils/plooto';

const API_PREFIX = 'v1';

export class EmailMoneyTransferViewModel {
  public id: string;

  public securityQuestion: number;

  public status: string;

  public skipSecurityQuestions: boolean;

  public prefillFromName: string;

  public prefillCountry: string;

  public prefillCurrency: string;

  public payeeEmailKey: string;

  public bankDetailsRequired: boolean;

  public isSecondaryBankLoginEnabled: boolean;

  public companyCountry: string;

  public companyName: string;
}

export class EmailMoneyTransferDetailsViewModel {
  public amount: number;

  public from: string;

  public country: string;

  public currency: string;

  public expiry: string;

  public canReuseAccount: string;

  public lastBankDisplayName: string;

  public maskedAccountNumber: string;
}
export class EmailMoneyTransferBankingDetailsViewModel {
  public amount: number;

  public from: string;

  public country: string;

  public currency: string;

  public expiry: string;
}

export class EmailMoneyTransferConfirmationViewModel {
  public bankName: string;

  public selectedAccountName: string;

  public requiresConfirmation: boolean;

  public optedIntoMarketingCommunications: boolean;
}

export class EmailMoneyTransferService {
  private userService: userService.UserService;

  constructor() {
    this.userService = userService.Instance;
  }

  public GetByEmailKey(emailKey: string): JQueryPromise<EmailMoneyTransferViewModel> {
    return system
      .defer<EmailMoneyTransferViewModel>((dfd) => {
        this.userService
          .AuthorizedGet(
            `${import.meta.env.APP_URLS_API_URL}/${API_PREFIX}/emailMoneyTransfers/${emailKey}`
          )
          .done((emailMoneyTransfer) => {
            if (
              plootoUtils.IsNullOrUndefined(emailMoneyTransfer) ||
              emailMoneyTransfer.error === true
            ) {
              dfd.reject(emailMoneyTransfer);
              return;
            }
            dfd.resolve(emailMoneyTransfer);
          })
          .fail(() => {
            dfd.reject();
          });
      })
      .promise();
  }

  public AnswerSecurityQuestion(
    emailKey: string,
    securityAnswer: string
  ): JQueryPromise<EmailMoneyTransferDetailsViewModel> {
    return system
      .defer<EmailMoneyTransferDetailsViewModel>((dfd) => {
        this.userService
          .AuthorizedPost(
            `${
              import.meta.env.APP_URLS_API_URL
            }/${API_PREFIX}/emailMoneyTransfers/${emailKey}/answerSecurityQuestion`,
            {
              securityAnswer,
            }
          )
          .done((emailMoneyTransferDetails) => {
            if (
              plootoUtils.IsNullOrUndefined(emailMoneyTransferDetails) ||
              emailMoneyTransferDetails.error === true
            ) {
              dfd.reject(emailMoneyTransferDetails);
              return;
            }
            dfd.resolve(emailMoneyTransferDetails);
          })
          .fail(() => {
            dfd.reject();
          });
      })
      .promise();
  }

  public SubmitBankingInformation(
    emailKey: string,
    submitData: any
  ): JQueryPromise<EmailMoneyTransferConfirmationViewModel> {
    return system
      .defer<EmailMoneyTransferConfirmationViewModel>((dfd) => {
        this.userService
          .AuthorizedPost(
            `${
              import.meta.env.APP_URLS_API_URL
            }/${API_PREFIX}/emailMoneyTransfers/${emailKey}/submitBankingInformation`,
            submitData
          )
          .done((emailMoneyTransferDetails) => {
            if (
              plootoUtils.IsNullOrUndefined(emailMoneyTransferDetails) ||
              emailMoneyTransferDetails.error === true
            ) {
              dfd.reject(emailMoneyTransferDetails);
              return;
            }
            dfd.resolve(emailMoneyTransferDetails);
          })
          .fail(() => {
            dfd.reject();
          });
      })
      .promise();
  }
}

export const Instance = new EmailMoneyTransferService();
